module.exports = __webpack_public_path__ + "static/media/turtly_circle.a0c7a073.png";